import { validSeoPath } from 'shared/util/formatting';

import flight from './flight.json';
import hotel from './hotel.json';
import prepackage from './prepackage.json';

type FlightGeo = {
    country: string;
    fromCities: string[];
};

type CountryCity = {
    country: string;
    city?: string;
};
type OtherGeo = Array<string | CountryCity>;

const makeValidPath = (pathElements: (string | undefined)[]) =>
    pathElements
        .filter((pathElement) => pathElement !== undefined)
        .map((pathElement) => validSeoPath(pathElement))
        .join('/');

const renderTableFlight = ([toCity, data]: [string, FlightGeo]) => (
    <div className="place-content-center" key={`dlt${toCity}`}>
        <table className="w-full text-left mt-12">
            <thead>
                <tr className="s-bg-subtle">
                    <th className="px-16 py-8 border-b">Fly til {toCity}</th>
                </tr>
            </thead>
            <tbody>
                {data.fromCities.map((fromCity: string) => (
                    <tr key={`dlt${fromCity}`}>
                        <td className="px-16 py-8 border-b">
                            <a href={`/reise/flybilletter/norge/${makeValidPath([fromCity, data.country, toCity])}/`} className="block">
                                {fromCity} → {toCity}
                            </a>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

const renderTableOther = (pathPrefix: string, [toPlace, otherGeo]: [string, OtherGeo]) => {
    const extractCountryCity = (countryCity: string | CountryCity) => {
        if (typeof countryCity === 'string') {
            return {
                toCountry: toPlace,
                toCity: countryCity,
            };
        } else {
            return {
                toCountry: countryCity.country,
                toCity: countryCity.city,
            };
        }
    };

    return (
        <div className="place-content-center" key={`dlt${toPlace}`}>
            <table className="w-full text-left mt-12">
                <thead>
                    <tr className="s-bg-subtle">
                        <th className="px-16 py-8 border-b">{toPlace}</th>
                    </tr>
                </thead>
                <tbody>
                    {otherGeo.map((countryCity: string | CountryCity) => {
                        const { toCountry, toCity } = extractCountryCity(countryCity);

                        return (
                            <tr key={`dlt${toCountry}${toCity}`}>
                                <td className="px-16 py-8 border-b">
                                    <a href={`/reise/${makeValidPath([pathPrefix, toCountry, toCity])}/`} className="block">
                                        {toCity || toCountry}
                                    </a>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export const InternalLinks = () => (
    <>
        <section className="mb-32 px-16" aria-labelledby="seo-flights-to-popular-cities">
            <h3 id="seo-flights-to-popular-cities">Finn flyreiser til populære byer</h3>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-16">{Object.entries(flight).map(renderTableFlight)}</div>
        </section>
        <section className="mb-32 px-16" aria-labelledby="seo-pp-to-exciting-places">
            <h3 id="seo-pp-to-exciting-places" className="t3">
                Finn pakkereiser til spennende steder
            </h3>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-16">
                {Object.entries(prepackage).map((entry) => renderTableOther('pakkereiser', entry))}
            </div>
        </section>
        <section className="mb-32 px-16" aria-labelledby="seo-cheap-hotels-in-europe">
            <h3 id="seo-cheap-hotels-in-europe">Finn rimelige hoteller i Europa</h3>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-16">
                {Object.entries(hotel).map((entry) => renderTableOther('hotell', entry))}
            </div>
        </section>
    </>
);
